import Vue from 'vue';

import store from '../store';

// Helper to get fresh permissions from store
const getPermissions = () => {
	const user = store.state.auth.user;
	if (!user) return [];

	// Super Admin (ID 1) bypass
	if (user.id === 1) return ['*']; // Special marker for super admin

	let perms = user.profile ? user.profile.permissions.map(x => x['permission']) : [];

	// Individual overrides (Check for 1, true or "1")
	if (user.custom_perm_sensitive_data == 1 || user.custom_perm_sensitive_data === true) perms.push('sensitive_data');
	if (user.custom_perm_permissions == 1 || user.custom_perm_permissions === true) perms.push('permissions');

	return perms;
};

export const checkPermission = (permission) => {
	const user = store.state.auth.user;
	if (user && user.id === 1) return true;

	const perms = getPermissions();
	return perms.includes(permission);
};

Vue.directive('can', {
	bind: function (el, binding) {
		// Initial check
		handleVisibility(el, binding);
	},
	update: function (el, binding) {
		// Reactive update
		handleVisibility(el, binding);
	}
});

function handleVisibility(el, binding) {
	const user = store.state.auth.user;
	const permission = binding.value;

	// Default to hidden if no user yet to avoid flicker of forbidden content
	if (!user) {
		el.style.display = 'none';
		return;
	}

	const perms = getPermissions();
	const hasPerm = (user.id === 1) || perms.includes(permission);

	if (!hasPerm) {
		el.style.display = 'none';
		// We could use a comment placeholder here for true "removal" that is restorable, 
		// but display:none is the most compatible way for now.
	} else {
		el.style.display = '';
	}
}



